import React, { useState, useEffect } from 'react';
import { useQuoteStore } from '@/store/quoteStore';
import { Button } from '@/components/ui/button';
import { ArrowLeft, AlertCircle } from 'lucide-react';

const Step3Wastage = () => {
  const { wastage, setWastage, setCurrentStep } = useQuoteStore();
  const [selected, setSelected] = useState(wastage);

  useEffect(() => {
    setSelected(wastage);
  }, [wastage]);

  const handleNext = () => {
    if (selected) {
      setWastage(selected);
      setCurrentStep(4);
    }
  };

  const handleBack = () => {
    setCurrentStep(2);
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 md:p-8">
      <h2 className="text-2xl md:text-3xl font-bold text-[#27292E] mb-2">
        Wastage
      </h2>
      <p className="text-gray-600 mb-6">
        Select the wastage percentage for your project.
      </p>

      <div className="bg-[#E0E9EB] border-l-4 border-[#2F5E96] rounded-lg p-4 mb-8">
        <div className="flex gap-3">
          <AlertCircle className="w-5 h-5 text-[#2F5E96] flex-shrink-0 mt-0.5" />
          <p className="text-sm text-gray-700">
            <strong>Recommendation:</strong> 20% wastage is recommended when installing the ProBound Surface mixes over irregular bases such as porous concrete.
          </p>
        </div>
      </div>

      <div className="space-y-4">
        <div
          className={`border-2 rounded-xl p-5 cursor-pointer transition-all ${
            selected === 'No wastage'
              ? 'border-[#2F5E96] bg-[#2F5E96]/5'
              : 'border-gray-200 hover:border-[#2F5E96]/50'
          }`}
          onClick={() => setSelected('No wastage')}
          data-testid="wastage-none"
        >
          <div className="flex items-center justify-between">
            <div className="text-lg font-bold text-[#27292E]">No wastage</div>
            <div className="text-sm text-gray-500">0%</div>
          </div>
        </div>

        <div
          className={`border-2 rounded-xl p-5 cursor-pointer transition-all ${
            selected === '10%'
              ? 'border-[#2F5E96] bg-[#2F5E96]/5'
              : 'border-gray-200 hover:border-[#2F5E96]/50'
          }`}
          onClick={() => setSelected('10%')}
          data-testid="wastage-10"
        >
          <div className="flex items-center justify-between">
            <div className="text-lg font-bold text-[#27292E]">10% wastage</div>
            <div className="text-sm text-[#2F5E96] font-medium">Recommended</div>
          </div>
        </div>

        <div
          className={`border-2 rounded-xl p-5 cursor-pointer transition-all ${
            selected === '20%'
              ? 'border-[#2F5E96] bg-[#2F5E96]/5'
              : 'border-gray-200 hover:border-[#2F5E96]/50'
          }`}
          onClick={() => setSelected('20%')}
          data-testid="wastage-20"
        >
          <div className="flex items-center justify-between">
            <div className="text-lg font-bold text-[#27292E]">20% wastage</div>
          </div>
        </div>
      </div>

      <div className="flex gap-4 mt-8">
        <Button
          onClick={handleBack}
          variant="outline"
          className="flex-1 h-14 text-lg font-medium rounded-xl border-2 border-[#2F5E96] text-[#2F5E96] hover:bg-[#2F5E96]/5"
          data-testid="back-button-step3"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Back
        </Button>
        <Button
          onClick={handleNext}
          disabled={!selected}
          className="flex-1 bg-[#2F5E96] hover:bg-[#254b7a] text-white h-14 text-lg font-bold rounded-xl transition-transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
          data-testid="next-button-step3"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default Step3Wastage;